import { Injectable } from '@angular/core';
import {NotificationService} from "../root/toast/notification.service";

@Injectable()
export class ContractStatesService {

    states = {
        ACCEPTED: 'ACCEPTED',
        TACITLY_ACCEPTED: 'TACITLY_ACCEPTED',
        PENDING: 'PENDING',
        INVALIDATED: 'INVALIDATED',
        DISPUTED: 'DISPUTED',
        EXPIRED: 'EXPIRED',
        CREATED: 'CREATED'
    };

    constructor(private notificationService:NotificationService) {

    }

    showNotification(state, daysPassedSinceLastModification){
        if(this.isPENDING(state)){
            let keyText = '';

            if(daysPassedSinceLastModification == 0){
                keyText = 'pending_init';
            }else if(daysPassedSinceLastModification == 5){
                keyText = 'pending_ten_days_left';
            }else if((daysPassedSinceLastModification == 14)){
                keyText = 'pending_one_day_left';
            }

            if(keyText !== ''){
                this.notificationService.showToast('contract.terms.toast.title.' + keyText, 'contract.terms.toast.message.' + keyText, null,'INFO',10000);
            }

        }else if(this.isTACITLYACCEPTED(state)){
            this.notificationService.showToast('contract.terms.toast.title.accepted_auto', 'contract.terms.toast.message.accepted_auto',null,'INFO',10000);

        }else if(this.isINVALIDATED(state)){
            this.notificationService.showToast('contract.terms.toast.title.invalidated', 'contract.terms.toast.message.invalidated',null,'INFO',10000);
        }
    }

    isINVALIDATED(state){
        return state === this.states.INVALIDATED;
    }

    isPENDING(state){
        return state === this.states.PENDING;
    }

    isDISPUTED(state){
        return state === this.states.DISPUTED;
    }

    isEXPIRED(state){
        return state === this.states.EXPIRED;
    }

    isTACITLYACCEPTED(state){
        return state === this.states.TACITLY_ACCEPTED;
    }

    isCREATED(state){
        return state === this.states.CREATED;
    }

    isACCEPTED(state){
        return state === this.states.ACCEPTED;
    }

}


// WEBPACK FOOTER //
// ./public/upgrade/core/contract_states.service.ts